export function populateAddressFields(deliveryState, address) {
    deliveryState.address1 = address.line_1;
    deliveryState.address2 = address.line_2;
    deliveryState.address3 = address.line_3;
    deliveryState.county = address.county;
    deliveryState.country = address.country_iso_2;
    deliveryState.postcode = address.postcode;
    deliveryState.town = address.post_town;
}

export function filterPostageOptions(postageOptions, country, domesticCountries, selfFulfilCountries) {
    return postageOptions.filter(option => {
        if (selfFulfilCountries.includes(country)) {
            return option.self_fulfil_only;
        }

        return option.overseas === isShippingOverseas(country, domesticCountries) && !option.self_fulfil_only;
    });
}

export function isShippingOverseas(country, domesticCountries) {
    return !domesticCountries.includes(country);
}

export function selectDefaultCombinedPackaging(order) {
    if (!order.combinePackagedVouchers || order.combinedPackagingId) {
        return;
    }

    const fallback = document.querySelector('input[name="combined_packaging_id"]');

    if (fallback) {
        order.combinedPackagingId = fallback.value;
    }
}
